import { Injectable } from '@angular/core';
import { UserModel } from 'src/app/models/User';
import { DashboardDealCardDto } from 'src/app/models/DealsModels';
import { getBucketForId, MembershipBucket } from 'src/app/models/SubscriptionsModels';
import { DateTime, Interval } from 'luxon';


@Injectable({ providedIn: 'root' })
export class UnlockedStarterDealsService {
    private unlocked = new Set<number>();

    computeFrom(deals: DashboardDealCardDto[], user: UserModel): void {
        this.unlocked.clear();

        if (!user || !deals.length || !user.isFree) {
            return;
        }
        const signupMs = new Date(user.signupDate).getTime() * 1000;
        const signup = DateTime.fromMillis(signupMs);
        const windowStart = signup.minus({ hours: 72 });
        const windowInterval = Interval.fromDateTimes(windowStart, signup);
        const inWindowIds = deals
            .filter(d => {
                // createdAt is an ISO datetime now; derive seconds to preserve the prior arithmetic.
                const parsed = DateTime.fromISO(d.createdAt).toSeconds() * 1000;
                const dealTime = DateTime.fromMillis(parsed);
                const withinWindow = windowInterval.contains(dealTime);
                const hasMembership = user.membershipId >= d.minimumTier;
                return withinWindow && hasMembership;
            })
            .sort((a, b) => DateTime.fromISO(b.createdAt).toMillis() - DateTime.fromISO(a.createdAt).toMillis())
            .slice(0, 3)
            .map(d => d.id);

        this.unlocked = new Set(inWindowIds);
    }

    isUnlocked(dealId: number): boolean {
        return this.unlocked.has(dealId);
    }
}
